
const SearchEntity = ({listName, currValue, choices, changeHandler}) => {

    return (
    <>
        <input type="text" list={listName} size="120" onChange={changeHandler} />
        <datalist id={listName}>
            {choices.map(opt =>
                <option key={opt.id} value={opt.id}>{opt.label}</option>
            )}
        </datalist>
    </>
    )
}

export default SearchEntity